import React, { useState, useEffect } from 'react';
import { Card, Typography, message } from 'antd';
import axios from 'axios';
import OrderList from './orders/OrderList';
import OrderDetailModal from './orders/OrderDetailModal';
import './MyOrders.css';

const { Title } = Typography;

const DEFAULT_PAGE_SIZE = 500;

const MyOrders = () => {
  const [loading, setLoading] = useState(true);
  const [userData, setUserData] = useState(null);
  const [orders, setOrders] = useState([]);
  const [searchResults, setSearchResults] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: DEFAULT_PAGE_SIZE,
    total: 0
  });
  const [originalPagination, setOriginalPagination] = useState(null);

  const fetchOrders = async (page = 1, pageSize = DEFAULT_PAGE_SIZE) => {
    try {
      setLoading(true);
      const response = await axios.get(`/api/orders/?page=${page}&page_size=${pageSize}`);
      setOrders(response.data.results);
      const newPagination = {
        current: page,
        pageSize: pageSize,
        total: response.data.count
      };
      setPagination(newPagination);
      // Store original pagination when not in search mode
      if (!searchResults) {
        setOriginalPagination(newPagination);
      }
    } catch (error) {
      console.error('Error fetching orders:', error);
      message.error('加载订单数据失败');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await axios.get('/api/users/profile/');
        setUserData(response.data);
      } catch (error) {
        console.error('Error fetching user data:', error);
        message.error('加载用户数据失败');
      }
    };

    fetchUserData();
    fetchOrders();
  }, []);

  const handleOrderClick = (order) => {
    setSelectedOrder(order);
    setModalVisible(true);
  };

  const handlePageChange = (page, pageSize) => {
    // Only fetch orders if not in search mode
    if (!searchResults) {
      fetchOrders(page, pageSize);
    }
  };

  const handleSearchResults = (results) => {
    // Store current pagination before switching to search mode
    if (!searchResults) {
      setOriginalPagination(pagination);
    }
    setSearchResults(results);
    setPagination({
      current: 1,
      pageSize: results.length,
      total: results.length
    });
  };

  const handleClearSearch = () => {
    setSearchResults(null);
    // Restore original pagination settings
    if (originalPagination) {
      fetchOrders(originalPagination.current, originalPagination.pageSize);
    } else {
      fetchOrders(1, DEFAULT_PAGE_SIZE);
    }
  };

  return (
    <div className="mock-pack-container">
      <Card className="user-panel">
        <OrderList
          orders={searchResults || orders}
          loading={loading}
          pagination={pagination}
          onPageChange={handlePageChange}
          onOrderClick={handleOrderClick}
          onOrdersUpdate={searchResults ? handleSearchResults : fetchOrders}
          onSearchResults={handleSearchResults}
          onClearSearch={handleClearSearch}
          isSearchMode={!!searchResults}
          showBatchButtons={true}
          isMyOrdersRoute={true}
        />
      </Card>

      <OrderDetailModal
        visible={modalVisible}
        order={selectedOrder}
        onClose={() => setModalVisible(false)}
      />

    </div>
  );
};

export default MyOrders;
